export function MiniChangelogSkeleton() {
  return (
    <div
      style={{width: 175}}
      className="flex flex-col rounded-t-md bg-gray-800"
    >
      <Skeleton className="rounded-t-md" />
      <Skeleton />
      <Skeleton />
    </div>
  );
}

function Skeleton({className}: {className?: string}) {
  return (
    <div className="animate-pulse">
      <div
        style={{height: 29}}
        className={`flex flex-row pl-4 items-center pr-2 py-2 ${className}`}
      >
        <div
          style={{width: 15, height: 15}}
          className="mr-2 rounded-full bg-gray-600 dark:bg-gray-700"
        ></div>
        <div className="flex flex-col gap-1">
          <div
            style={{height: 7, width: 120}}
            className="rounded-full bg-gray-600 dark:bg-gray-700"
          ></div>
          <div
            style={{height: 6, width: 40}}
            className="rounded-full bg-gray-600 dark:bg-gray-700"
          ></div>
        </div>
      </div>
    </div>
  );
}
